import styled from '@emotion/styled';
import { FONT_SIZE, COLOR } from '@ordermentum/ui-constants';

const Container = styled('div')``;

const CenterContainer = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;

  > p {
    font-size: 0.8rem;

    a {
      text-decoration: underline;
      color: ${COLOR.ORANGE};
    }
  }
`;

const TermsAndConditionContainer = styled('div')`
  text-align: center;
`;

const SubText = styled('div')`
  font-size: ${FONT_SIZE.SM};
`;

const OrangeText = styled('a')`
  color: ${COLOR.ORANGE};
`;

export {
  CenterContainer,
  Container,
  TermsAndConditionContainer,
  SubText,
  OrangeText,
};
